import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import React, { useContext, useEffect, useState } from "react";
import "./loginB.css";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { sha512 } from "js-sha512";
import apiUrl from "../../utils/ApiConfig";
import AlertA from "../../utils/AlertA";
import { MainContext } from "../../contexts/MainContext";

export default function LoginB() {
  const navigat = useNavigate();
  let { user, setUser } = useContext(MainContext);

  const alertX = (text) =>
    AlertA("center", "success", "خوش آمدید ...", 2500, "#9933cc", "#9933cc");

  const alertY = (text) =>
    AlertA("center", "error", text, 2500, "#9933cc", "#9933cc");

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });
  ////////////////////////
  const handleRegistration = (data) => {
    let obj = {
      un: data.phone,
      pw: sha512(data.password),
    };
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/User/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        if (res.ok) {
          return res.json().then((result) => {
            alertX();
            setUser(true);
            navigat("./selection");
          });
        } else {
          return res.json().then((err) => {
            alertY(err.msg);
          });
        }
      });
    }
    myApp();
  };
  return (
    <>
      {!user && (
        <>
          <Form onSubmit={handleSubmit(handleRegistration)}>
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>شماره همراه:</Form.Label>
              <Form.Control
                type="number"
                placeholder="شماره همراه خود را وارد کنید . ."
                {...register("phone", {
                  required: " شماره همراه الزامی است",
                  minLength: 11,
                  maxLength: 11,
                })}
                isInvalid={!!errors.phone}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phone?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>رمز عبور:</Form.Label>
              <Form.Control
                type="password"
                placeholder=" رمز عبور خود را وارد کنید . ."
                {...register("password", {
                  required: "رمز عبور الزامی است (حداقل 4کاراکتر) ",
                  minLength: 4,
                })}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <p class="mb-3">
              حساب کاربری ندارید ؟
              <Link
                to="/signup"
                className="font-danaDemiBold"
                style={{ color: "#9933cc" }}
              >
                {""} ثبت نام کنید...
              </Link>
            </p>

            <p className="forgat-p">رمز عبور را فراموش کره ام ...</p>

            <Button type="submit" variant="primary">
              ورود
            </Button>
          </Form>
        </>
      )}
    </>
  );
}
